/* global axios */

import ApiClient from '../ApiClient';

class WoocommerceAPI extends ApiClient {
  constructor() {
    super('integrations/woocommerce', { accountScoped: true });
  }

  getOrders(hookId, contactId) {
    return axios.get(`${this.url}/${hookId}/orders`, {
      params: { contact_id: contactId },
    });
  }

  getOrderDetails(hookId, orderId) {
    return axios.get(`${this.url}/${hookId}/orders/${orderId}`);
  }

  syncPreview(hookId) {
    return axios.get(`${this.url}/${hookId}/sync_preview`);
  }

  syncStatus(hookId) {
    return axios.get(`${this.url}/${hookId}/sync_status`);
  }

  syncStart(hookId) {
    return axios.post(`${this.url}/${hookId}/sync_start`);
  }
}

export default new WoocommerceAPI();
